import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ArrowStepperItem } from './arrow-stepper-item.model';

@Component({
  selector: 'syslink-arrow-stepper-item',
  templateUrl: './arrow-stepper-item.component.html',
  styleUrls: ['./arrow-stepper-item.component.scss']
})
export class ArrowStepperItemComponent implements OnInit {
  public highlight: boolean = false;
  @Input() item: ArrowStepperItem = new ArrowStepperItem();
  @Output() clicked: EventEmitter<ArrowStepperItem> = new EventEmitter<ArrowStepperItem>();

  ngOnInit(): void {
    this.highlight = this.item.active;
  }

  public onItemClick() {
    if (this.clicked.observed) {
      this.clicked.emit();
    }
  }
}
